import React, { type ReactNode } from "react";
import {
  DefualtContent,
  LeftSideContent,
  OrderedList,
  RightSideContent,
  SectionContent,
  SectionText,
  SectionTextBox,
  StyledSection,
  UnorderedList,
  UnorderedListDot, 
} from "./Section.styled";

import SectionHeader from "../SectionHeader/SectionHeader";
import useTheme from "../../hooks/useTheme";
import { Trans, useTranslation } from "react-i18next";

interface SectionProps {
  header?: string;
  withBackgroundImg?: boolean;
  children?: ReactNode;
  text?: string;
  textKey?: string;
  asideContent?: ReactNode;
  textFontSize?: string;
  reverse?: boolean;
  row?: boolean;
  sectionStyle?: React.CSSProperties;
  leftSideContentStyle?: React.CSSProperties;
}

const Section: React.FC<SectionProps> = ({
  header,
  children,
  text,
  textKey,
  withBackgroundImg = false,
  asideContent,
  textFontSize,
  reverse = false,
  row = false,
  sectionStyle,
  leftSideContentStyle,
}) => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const color = withBackgroundImg ? theme.colors.white : undefined;
  return (
    <StyledSection $withBackgroundImg={withBackgroundImg}>
      <SectionContent $reverse={reverse} $row={row} style={sectionStyle}>
        <DefualtContent>
          <LeftSideContent style={leftSideContentStyle}>
            {header && (
              <SectionHeader
                title={header}
                showRectangle={!withBackgroundImg}
                color={color}
              />
            )}
            {text && (
              <SectionText $color={color} $fontSize={textFontSize}>
                {text}
              </SectionText>
            )}
            {textKey && (
              <SectionTextBox $color={color} $fontSize={textFontSize}>
                <Trans
                  t={t}
                  i18nKey={textKey}
                  components={{
                    1: <OrderedList />,
                    2: <li></li>,
                    3: <UnorderedList></UnorderedList>,
                    4: <h3></h3>,
                    5: <span style={{ fontWeight: "bold" }}></span>,
                    6: <UnorderedListDot />
                  }}
                />
              </SectionTextBox>
            )}
          </LeftSideContent>
          {asideContent && <RightSideContent>{asideContent}</RightSideContent>}
        </DefualtContent>
        {children}
      </SectionContent>
    </StyledSection>
  );
};

export default Section;
